const getMetrics = (visits: any) => {
  if (visits === undefined) {
    return { exited: 0, stayed: 0, total: 0 };
  }
  const exited: number = visits.filter(
    (visit: any) => visit.timeout !== null
  ).length;
  const total: number = visits.length;
  const stayed: number = total - exited;

  return { exited, stayed, total };
};
export default getMetrics;
